import { FC, useState } from 'react';
import { Typography } from 'antd';

import { ActionButton } from '../../../../components/ActionButton';
import { CallbackRequestModal } from '../CallbackRequestModal';

import styles from './styles.module.css';

const { Text } = Typography;

interface Props {
    taskId: number;
    isCanceled: boolean;
}

export const CallbackRequest: FC<Props> = ({ taskId, isCanceled }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isRegistered, setIsRegistered] = useState(false);

    return (
        <div className={styles.callbackRequest}>
            <div className={styles.infoBox}>
                <Text className={styles.infoPrimary}>
                    Рекомендуем предложить клиенту самостоятельно связаться по номеру, указанному в СМС, либо
                    воспользоваться личным кабинетом по ссылке из сообщения.
                </Text>
                <Text className={styles.infoSecondary}>
                    СМС с номером телефона и ссылкой на личный кабинет автоматически направляется клиенту при
                    принятии задания в работу.
                </Text>
            </div>

            {isRegistered ? (
                <div className={styles.registeredNotice}>
                    <Text className={styles.registeredTitle}>Обращение зарегистрировано</Text>
                    <Text className={styles.registeredText}>
                        Мы свяжемся с клиентом в ближайшее рабочее время. 
                        График работы кураторов: ежедневно с 09:00 до 18:00 (МСК).
                    </Text>
                </div>
            ) : (
                <>
                    <Text className={styles.callbackHint}>
                        Если клиент настаивает на обратной связи со стороны Вауворкс — нажмите кнопку{' '}
                        <span className={styles.callbackHintBold}>«Перезвоните клиенту»</span> и подробно опишите
                        суть обращения.
                    </Text>
                    <div className={styles.callbackButton}>
                        <ActionButton
                            onClick={() => setIsModalOpen(true)}
                            disabled={isCanceled}
                            tooltip={isCanceled ? 'Нельзя запросить звонок, так как задание отменено' : undefined}
                        >
                            Перезвоните клиенту
                        </ActionButton>
                    </div>
                </>
            )}

            {isModalOpen && (
                <CallbackRequestModal
                    taskId={taskId}
                    onClose={() => setIsModalOpen(false)}
                    onSuccess={() => {
                        setIsModalOpen(false);
                        setIsRegistered(true);
                    }}
                />
            )}
        </div>
    );
};
